import React, { ReactNodeArray } from 'react'
import { ProjectGroup } from 'admin-web-utils'
import { Accordion, AuthGuard, PageHeading, Page } from 'admin-web-ui'
import { ClientConfig } from './ClientConfig/ClientConfig'
import { TestRegistrationKeys } from './TestRegistrationKeys'
import { UploadDeviceCheckKey } from './UploadDeviceCheckKey'
import { AndroidSigningCertificates } from './AndroidSigningCertificates'
import { PackageNameWhitelisting } from './AndroidSettings'
import { useConsoleContext } from '../../containers/Console'
import styled from 'styled-components'
import { versionFull } from '../../webpack-vars'
import { useProjectContext } from '../../containers/Project'

const AccordionContainer = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 12%);
  background-color: white;
`

const VersionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`

export const ProjectSettings: React.FC = () => {
  const { remotes } = useConsoleContext()
  const {
    me: { authGroups },
    currentProject,
  } = useProjectContext() ?? {}

  const mapRemoteVersions = (): ReactNodeArray => {
    const versions = []
    for (const remote in remotes) {
      const {
        routeProps: { displayName },
        version,
      } = remotes[remote]
      if (version) {
        versions.push(
          <div key={displayName}>
            <b>{displayName}:</b> {version}
          </div>,
        )
      }
    }
    return versions
  }
  return (
    <Page>
      <PageHeading>Settings</PageHeading>
      <AuthGuard
        projectId={currentProject.id}
        authGroups={authGroups}
        required={[ProjectGroup.Developer, ProjectGroup.Admin]}
      >
        <ClientConfig />
        <UploadDeviceCheckKey />
        <TestRegistrationKeys />
        <AndroidSigningCertificates />
        <PackageNameWhitelisting />
        <AccordionContainer>
          <Accordion title="UI Version Info">
            <div>
              <b>Console:</b> {versionFull}
            </div>
            <VersionsContainer>{mapRemoteVersions()}</VersionsContainer>
          </Accordion>
        </AccordionContainer>
      </AuthGuard>
    </Page>
  )
}
